import React from 'react';
import loadable from '@loadable/component';

const CarLoanCalculatorComponent = (props) => {
  const Component = loadable(() => import('./CarLoanCalculator.js'), { ssr: false });
  return <Component {...props} />;
};

export default CarLoanCalculatorComponent;
